import { FormField, Heading, ReadOnlyField } from '@msaf/core-react'
import { TOOLTIP } from '../../../../constants/tooltips'
import { AquiferViewFormInterface } from './aquifer-test-details-view'

export default function AquiferTestQualityRatingFormEdit({ fields, isLoading }: AquiferViewFormInterface) {
  return (
    <>
      <Heading isSkeleton={isLoading} level={3}>
        Quality rating
      </Heading>

      <FormField
        toolTipMessage={TOOLTIP.testRatingId}
        isSkeleton={isLoading}
        label='Test setup and report'
        labelId='testRatingLabel'
      >
        <ReadOnlyField isSkeleton={isLoading} labelledBy='testRatingLabel' value={`${fields.testRating ?? ''}`} />
      </FormField>

      <FormField
        toolTipMessage={TOOLTIP.parameterAccuracyId}
        isSkeleton={isLoading}
        label='Test analysis and parameters'
        labelId='parameterAccuracyLabel'
      >
        <ReadOnlyField
          isSkeleton={isLoading}
          labelledBy='parameterAccuracyLabel'
          value={`${fields.parameterAccuracy ?? ''}`}
        />
      </FormField>
    </>
  )
}
